import { render, staticRenderFns } from "./purchase.vue?vue&type=template&id=69202296"
import script from "./purchase.ts?vue&type=script&lang=js&external"
export * from "./purchase.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports